import { Typography, styled } from '@mui/material';

export const LabelContainerStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  background: theme.palette.dark.dark_6,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  width: '50vw',
}));

export const IndexContainerStyled = styled(Typography)(({ theme }) => ({
  width: 20,
  textAlign: 'center',
}));
